export default "__VITE_ASSET__d7c86df2__"